import { PublicClient, useQuery } from 'wagmi';

import VestaSubgraph from '~services/subgraph/vesta';

import { useVestaSubgraph } from './graph/useVestaSubgraph';
import { useSession } from './useSession';

const CHECK_TIMEOUT_MS = 10_000;

async function check(graph: VestaSubgraph, checkBlock: number) {
  return new Promise<boolean>(res =>
    setTimeout(async () => {
      try {
        await graph.checkBlock(checkBlock);
        res(true);
      } catch (err) {
        res(false);
      }
    }, CHECK_TIMEOUT_MS),
  );
}

async function checkRoutine(graph: VestaSubgraph, publicClient: PublicClient, checkAmount = 6) {
  const checkBlock = await publicClient.getBlockNumber();
  let tryCount = 0;
  let done = false;
  let isGraphValid = false;

  while (!done) {
    if (tryCount <= checkAmount) isGraphValid = await check(graph, Number(checkBlock));
    else done = true;

    if (!isGraphValid) {
      tryCount++;
    } else {
      done = true;
    }
  }

  return isGraphValid;
}

export const useGraphStatus = (checkAmount = 6) => {
  const graph = useVestaSubgraph();
  const { publicClient } = useSession();

  const res = useQuery(
    ['graph-is-fetchable'],
    async () => await checkRoutine(graph, publicClient, checkAmount),
    {
      refetchInterval: CHECK_TIMEOUT_MS,
      enabled: !!publicClient,
    },
  );

  return { ...res, data: false };
};
